export const getQueryDate = (year, month = 1, day = 1) => {
    const d = new Date();
    d.setFullYear(year, month - 1);
    d.setDate(day);
    d.setHours(0, 0, 0, 0);
    return d;
};
//# sourceMappingURL=time.js.map